export default __webpack_public_path__ + "static/media/loan.60159c48.png";